export enum Resource {
  ALL = '.',
  ANY = 'any',
  INVITATION = '.invitation',
  STUDENT_BASIC = '.student.basic',
  STUDENT_SENSITIVE = '.student.sensitive',
  EMPLOYEE_INFO = '.employee.info',
  EMPLOYEE_PAYOUT = '.employee.payout',
  EMPLOYEE_PAYSOURCE = '.employee.paySource',
  EMPLOYEE_AVAILABILITY = '.employee.availability',
  EMPLOYEE_BALANCE_BASIC = '.employee.balance.basic',
  EMPLOYEE_BALANCE = '.employee.balance',
  EMPLOYEE_ABSENCE = '.employee.absence',
  EVENT_COMPLETE = '.event.complete',
  EVENT_NOTIFY = '.event.notify',
  EVENT_LESSON = '.event.lesson',
  EVENT_RENTAL = '.event.rental',
  PACKAGE = '.package',
  PAYMENT = '.payment.payment',
  PAYMENT_CATEGORY = '.payment.category',
  PAYMENT_METHOD = '.payment.method',
  PAYMENT_PROVIDER = '.payment.provider',
  INVOICE = '.invoice',
  PRODUCT = '.product',
  SHOP_ITEM = '.shop.item',
  VOUCHER = '.voucher',
  PREPAYMENT = '.prepayment',
  BOOKING = '.booking',
  CHANGELOG = '.changelog',
  DISCIPLINE = '.discipline',
  LOCATION = '.location',
  MESSAGING = '.messaging',
  FORM_FIELD = '.form.field',
  INVENTORY_ITEM = '.inventory.item',
  STORAGE = '.storage',
  BUSINESS_INFO = '.business.info',
  BUSINESS_SETTINGS = '.business.settings',
  BUSINESS_MEMBERSHIP = '.business.membership',
  BUSINESS_PUBLICACCOUNT = '.business.publicAccount',
  BUSINESS_STATITSTICS = '.business.statistics',
  BUSINESS_SUBSCRIPTION = '.business.subscription',
  WEBHOOK = '.webhook',
  LIVE_CHAT = '.liveChat',
}
